import React from 'react';
import Parsed from 'react-native-parsed-text';
import { theme, css } from 'constants';
import { WebBrowser, Text } from 'core';
import { reg } from 'utils';

let styles = css({
  text: {
    padding: 10,
    paddingBottom: 20
  },
  parsed_text: {
    color: theme.primary_color,
    paddingVertical: 2
  },
  1: { fontSize: 48, textAlign: 'center' },
  2: { fontSize: 36, textAlign: 'center' },
  3: { fontSize: 24, textAlign: 'center' }
});

export const TextMsg = ({ current_msg }) =>
  current_msg.parsed ? (
    <Parsed
      style={styles.text}
      parse={[
        {
          pattern: reg.url,
          style: styles.parsed_text,
          onPress: url => WebBrowser.goToUrl(url)
        },
        { pattern: reg.email, style: styles.parsed_text, onPress: email => WebBrowser.goToEmail(email) },
        { pattern: reg.tel, style: styles.parsed_text, onPress: tel => WebBrowser.goToTel(tel) }
      ]}
    >
      {current_msg.text}
    </Parsed>
  ) : (
    <Text style={[styles.text, current_msg.emoji && styles[current_msg.emoji]]}>{current_msg.text}</Text>
  );



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/text.js